// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/yxyweb/common/components/message-center/billdesign.less
// module id = 3178
// module chunks = 0